import forms from 'constants/forms';
import { useAminPanelSearchPatients } from 'infrastructure/hooks/patient/use-admin-panel-search-patient';
import { useCallback, useMemo } from 'react';
import { debounce } from 'lodash';

import { usePatientsFilter } from './use-patients-filter';

export const options = forms.adminPanelPatientFilter.map((opt) => ({
  value: opt.id,
  label: opt.label,
  placeholder: opt.placeholder,
}));

export const useFilter = () => {
  const { filter, updateFilter, resetFilter } = usePatientsFilter();
  const { searchPatients, searchPatientsLoading, patients } =
    useAminPanelSearchPatients();

  const placeholder = useMemo(
    () => options.find((o) => o.value === filter.patientKey)?.placeholder,
    [filter.patientKey],
  );

  const debounceSearchPatients = useCallback(debounce(searchPatients, 800), []);

  const patientOptions =
    patients?.data ??
    (filter.patientLabel && filter.patientGuid
      ? [{ label: filter.patientLabel, value: filter.patientGuid }]
      : []);

  const exclude = ['page', 'patientLabel', 'clinicLabel', 'patientKey'];

  const countOfChangedFilterField = Object.entries(filter).filter(
    ([k, v]) => !exclude.includes(k) && Boolean(v),
  ).length;

  return {
    filter,
    updateFilter,
    searchPatientsLoading,
    placeholder,
    debounceSearchPatients,
    patientOptions,
    countOfChangedFilterField,
    options,
    resetFilter,
  };
};
